import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";

/* Generic sub-page layout: hero + sections list + CTA-footer.
   Used for Hoe-werkt-het / Diensten / Over-ons / Kennisbank / Voor-installateurs.
   `sections` = [{ title, body, bullets?: [] }] */
export default function SubPage({ tKey, sections, image }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white text-[#0B1B2B] antialiased">
      <Header />

      <section className="bg-[#F7F8FA] pt-20 md:pt-28 pb-20">
        <div className="max-w-5xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.25em] text-[#1F3A60] font-medium mb-4">{t(`${tKey}.kicker`)}</div>
            <h1 className="font-serif text-4xl sm:text-5xl text-[#0B1B2B] leading-[1.1] mb-5">{t(`${tKey}.title`)}</h1>
            <p className="text-[#52606E] text-lg leading-relaxed">{t(`${tKey}.intro`)}</p>
          </div>
          {image && (
            <div className="lg:col-span-5">
              <img src={image} alt="" className="rounded-2xl w-full aspect-[4/3] object-cover shadow-xl shadow-[#0B1B2B]/10" />
            </div>
          )}
        </div>
      </section>

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-16">
          {sections.map((s, i) => (
            <article key={i} data-testid={`subpage-section-${i}`}>
              <h2 className="font-serif text-2xl sm:text-3xl text-[#0B1B2B] mb-4">{t(s.title)}</h2>
              <p className="text-[#52606E] leading-relaxed whitespace-pre-line">{t(s.body)}</p>
              {s.bullets && (
                <ul className="mt-5 space-y-2.5">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex items-start gap-3">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#F5C24C] mt-2.5 shrink-0" />
                      <span className="text-[#0B1B2B]">{t(b)}</span>
                    </li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-[#0B1B2B] to-[#1F3A60] text-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl mb-4">{t("ds.footer_cta.title")}</h2>
          <p className="text-white/80 mb-7 text-lg">{t("ds.footer_cta.subtitle")}</p>
          <Link to="/#zonnecheck" data-testid="subpage-cta"
            className="inline-flex items-center gap-2 bg-[#F5C24C] hover:bg-[#E5AE2F] text-[#0B1B2B] font-medium rounded-full px-8 py-4 transition-all">
            {t("ds.footer_cta.btn")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
